import { useContext, useEffect } from "react";

import { AppShellBreadcrumbContext, type AppShellBreadcrumbItem } from "./AppShellBreadcrumbContext";

export function useAppShellBreadcrumbItems(): AppShellBreadcrumbItem[] {
  const ctx = useContext(AppShellBreadcrumbContext);
  return ctx?.items ?? [];
}

export function useAppShellBreadcrumb(items: AppShellBreadcrumbItem[]): void {
  const ctx = useContext(AppShellBreadcrumbContext);
  const setItems = ctx?.setItems;
  const json = JSON.stringify(items);

  useEffect(() => {
    if (!setItems) return;
    setItems(JSON.parse(json) as AppShellBreadcrumbItem[]);
    return () => setItems([]);
  }, [json, setItems]);
}
